import { render, staticRenderFns } from "./ProjectSetting.vue?vue&type=template&id=2c9e60e6&scoped=true&"
import script from "./ProjectSetting.vue?vue&type=script&lang=js&"
export * from "./ProjectSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSetting.vue?vue&type=style&index=0&id=2c9e60e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e60e6",
  null
  
)

export default component.exports